import React, { Fragment, useState } from "react";
import { Modal, ModalBody, UncontrolledTooltip } from "reactstrap";

// redux
import { useDispatch } from "react-redux";
import { deleteAnnouncement } from "../../slices/apps/announcementSlice";

const AnnouncementDeleteModal = ({ id }) => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);

  const deleteAnnouncementFunc = async () => {
    try {
      const resultAction = await dispatch(deleteAnnouncement(id));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  function tog_large(e) {
    if (e) {
      setModal(true);
    } else setModal(false);
  }

  return (
    <Fragment>
      <span
        id={`announcement-delete-tooltipTop-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={() => tog_large(true)}
      >
        <i
          className="bx bx-trash text-danger"
          style={{
            fontSize: "20px",
          }}
        />
      </span>

      <UncontrolledTooltip
        placement="top"
        target={`announcement-delete-tooltipTop-${id}`}
      >
        Duyuruyu Sil
      </UncontrolledTooltip>

      <Modal
        fade={true}
        isOpen={modal}
        toggle={() => {
          setModal(false);
        }}
        centered={true}
      >
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <div className="mt-4 pt-2 fs-14 mx-4 mx-sm-5">
              <h4>Emin misiniz?</h4>
              <p className="text-muted mx-4 mb-0">
                Duyuruyu kalıcı olarak silmek istediğinize emin misiniz?
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              data-bs-dismiss="modal"
              onClick={() => {
                setModal(false);
              }}
            >
              Kapat
            </button>
            <button
              type="button"
              className="btn w-sm btn-danger "
              id="delete-record"
              onClick={() => {
                deleteAnnouncementFunc();
              }}
            >
              Evet, sil!
            </button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AnnouncementDeleteModal;
